module.exports = __webpack_public_path__ + "img/u2898.51e737dc.svg";